var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"school-content"},[_vm._m(0),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar"},[_c('div',{staticClass:"title"},[_vm._v("院校介绍")])])
}]

export { render, staticRenderFns }